import React from 'react';

import { Artwork as ArtworkCell } from '../common/container/Cell.jsx';
import { ArtworkGridContainer, Spaced } from '../common/container/Container.jsx';
import { default as FilterContainer } from '../common/container/Filter.jsx';
import { Indicator as LoadingIndicator } from '../common/container/Loading.jsx';
import { ListArtworkAdd } from '../common/container/Popup.jsx';
import { publicCompany } from '../common/publicCompany.ts';
import { Genre } from '../common/repository/Type.jsx';

let _BrowseInst;
class Browse extends React.Component {
    constructor(props) {
        super(props);

        let type;
        const pathComponents = location.pathname.split('/');
        if (pathComponents && pathComponents.length > 0) {
            type = pathComponents[pathComponents.length - 1];
        }
        this.state = {
            artwork: {
                loading: false,
                q: {
                    dir: 1,
                    limit: 20,
                    offset: 0,
                    order: 2
                }
            },
            type: type || 'browse'
        };

        this.sortOptions = [
            { display: 'Popular', value: 0 },
            // { display: 'Following', value: 1 },
            { display: 'Newest', value: 2 },
            { display: 'Suggested', value: 3 }
        ];

        this._handleFilterRef = this._handleFilterRef.bind(this);
        this.getArtwork = this.getArtwork.bind(this);
        this.handleArtworkLikeChange = this.handleArtworkLikeChange.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleFilterDisplayButtonClick = this.handleFilterDisplayButtonClick.bind(this);
        this.handleFilterHide = this.handleFilterHide.bind(this);
        this.handleFilterShow = this.handleFilterShow.bind(this);
        this.handleListArtworkAddModalClose = this.handleListArtworkAddModalClose.bind(this);
        this.handleSignUpClick = this.handleSignUpClick.bind(this);
        this.handleWaypointEnter = this.handleWaypointEnter.bind(this);
    }

    componentDidMount() {
        _BrowseInst = true;

        const state = this.state.artwork;
        const storageState = Artcloud.storage.get(Artcloud.storage.keys[this.state.type]);
        if (storageState) {
            let value;
            for (let id in storageState) {
                value = storageState[id];
                if (value == undefined) {
                    continue;
                }
                state.q[id] = value;
                if (id == 'q') {
                    this.setState({
                        search: value
                    });
                }
            }
            this.setState({
                artwork: state
            });
        }
        this.getArtwork();

        if (!this.filterRef) {
            return;
        }
        const filters = state.q;
        if (filters.minPrice || filters.maxPrice) {
            this.filterRef.handlePriceReset(filters.minPrice, filters.maxPrice);
        }
        if (filters.minHeight || filters.maxHeight) {
            this.filterRef.handleHeightReset(filters.minHeight, filters.maxHeight);
        }
        if (filters.minWidth || filters.maxWidth) {
            this.filterRef.handleWidthReset(filters.minWidth, filters.maxWidth);
        }
    }

    componentWillUnmount() {
        _BrowseInst = undefined;

        if (this.artworkRequest) {
            this.artworkRequest.abort();
            this.artworkRequest = null;
        }
    }

    _handleFilterRef(ref) {
        this.filterRef = ref;
    }

    getArtwork() {
        const state = this.state.artwork;
        if (state.loading) {
            return;
        }
        state.loading = true;
        this.setState({
            artwork: state
        });
        const query = { ...state.q };
        let item, data;
        for (let id in query) {
            data = query[id];
            if (!data) {
                continue;
            }
            if (data.value != undefined) {
                query[id] = data.value;
                continue;
            }
            if (!Array.isArray(data)) {
                continue;
            }
            if (data.length == 1) {
                item = data[0];
                query[id] = item.value;
            } else {
                for (let i = 0; i < data.length; i++) {
                    item = data[i];
                    query[`${id}[${i}]`] = item.value;
                }
                query[id] = undefined;
            }
        }
        switch (this.state.type) {
            case 'browse':
                query.type = 0;
                break;
            case 'decor':
                query.type = 8;
                break;
            case 'furniture':
                query.type = 6;
                break;
            case 'jewelry':
                query.type = 5;
                break;
            case 'lighting':
                query.type = 7;
                break;
        }
        this.artworkRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.art.get(),
            query,
            (responseData) => {
                this.artworkRequest = null;

                responseData.Data.forEach((d) => {
                    Artcloud.mkt.art._isfavorite(d);

                    d.ImgAlt = d.Title;
                    if (d.Artist && d.Artist.Name && d.Artist.Name.length) {
                        d.ImgAlt = d.Title + ' by ' + d.Artist.Name;
                    }
                });

                let data = state.data || [];
                state.data = data.concat(responseData.Data);
                state.q.offset += responseData.Data.length;
                state.hasMore = responseData.HasMore;

                state.loading = false;
                this.setState({
                    artwork: state
                });
            },
            (jqXHR, textStatus) => {
                this.artworkRequest = null;

                state.loading = false;
                this.setState({
                    artwork: state
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    handleArtworkLikeChange(d) {
        const state = this.state.artwork;
        let artwork;
        for (let i = 0; i < state.data.length; i++) {
            let temp = state.data[i];
            if (!temp || temp.ArtId != d.ArtId) {
                continue;
            }
            artwork = temp;
            break;
        }
        if (!artwork) {
            return;
        }
        const component = this;
        Artcloud.mkt.art.updateFavorite(artwork.ArtId, !artwork.IsFavorite, artwork.Title, function () {
            if (!_BrowseInst) {
                return;
            }
            artwork.IsFavorite = !artwork.IsFavorite;
            component.setState({
                artwork: state,
                listArtworkAddModal: {
                    data: artwork,
                    visible: true
                }
            });
        });
    }

    handleFilterChange(name, value, refresh) {
        if (this.artworkRequest) {
            this.artworkRequest.abort();
            this.artworkRequest = null;
        }
        const state = this.state.artwork;
        switch (name) {
            case 'search':
                this.setState({
                    [name]: value
                });
                return;
            case 'location':
            case 'period':
                let list;
                if (value != undefined) {
                    list = state.q[name] || [];
                    let removed = false;
                    let temp;
                    for (let i = 0; i < list.length; i++) {
                        temp = list[i];
                        if (temp.value == value.value) {
                            list.splice(i, 1);
                            removed = true;
                            break;
                        }
                    }
                    if (!removed) {
                        list = [value];
                    } else {
                        list = [];
                    }
                }
                state.q[name] = list;
                break;
            default:
                state.q[name] = value;
                break;
        }
        state.data = undefined;
        state.hasMore = undefined;
        state.q.offset = 0;

        this.setState({
            artwork: state
        }, () => {
            Artcloud.storage.put(Artcloud.storage.keys[this.state.type], state.q);
            if (refresh != false) {
                this.getArtwork();
            }
        });
    }

    handleFilterDisplayButtonClick(type) {
        switch (type) {
            case 'height':
                if (this.filterRef) {
                    this.filterRef.handleHeightReset();
                }
                this.handleFilterChange('minHeight', undefined, false);
                this.handleFilterChange('maxHeight', undefined);
                return;
            case 'price':
                if (this.filterRef) {
                    this.filterRef.handlePriceReset();
                }
                this.handleFilterChange('minPrice', undefined, false);
                this.handleFilterChange('maxPrice', undefined);
                return;
            case 'q':
                this.setState({
                    search: undefined
                });
                break;
            case 'width':
                if (this.filterRef) {
                    this.filterRef.handleWidthReset();
                }
                this.handleFilterChange('minWidth', undefined, false);
                this.handleFilterChange('maxWidth', undefined);
                return;
        }
        this.handleFilterChange(type, undefined);
    }

    handleFilterHide(event) {
        if (event) {
            event.preventDefault();
        }
        this.setState({
            filterVisible: false
        });
    }

    handleFilterShow(event) {
        if (event) {
            event.preventDefault();
        }
        this.setState({
            filterVisible: true
        });
    }

    handleListArtworkAddModalClose() {
        this.setState({
            listArtworkAddModal: undefined
        });
    }

    handleSignUpClick(event) {
        if (event) {
            event.preventDefault();
        }
        $('.overlay__container').addClass('overlay--active');
        $('.popup--signup').addClass('popup--active');
    }

    handleWaypointEnter() {
        if (!this.state.artwork.data || (this.state.artwork.data && this.state.artwork.hasMore == false)) {
            return;
        }
        this.getArtwork();
    }

    render() {
        let filterClassName = 'sidebar__container sidebar--filter';
        if (this.state.filterVisible) {
            filterClassName += ' sidebar--filter--active';
        }

        const filterRenderOptions = { colors: true, firstWidgetTitle: true, locations: true,  periods: true, price: true, search: true };
        let subTypes = [];
        let typeString;
        switch (this.state.type) {
            case 'decor':
                subTypes = [
                    <SubTypeFilterButton key="17" active={this.state.artwork.q.subType && this.state.artwork.q.subType.value == 17} d={{ display: 'Rugs & Carpets', value: 17 }} onClick={this.handleFilterChange} />,
                    <SubTypeFilterButton key="18" active={this.state.artwork.q.subType && this.state.artwork.q.subType.value == 18} d={{ display: 'Decorative Objects', value: 18 }} onClick={this.handleFilterChange} />,
                    <SubTypeFilterButton key="19" active={this.state.artwork.q.subType && this.state.artwork.q.subType.value == 19} d={{ display: 'Mirrors', value: 19 }} onClick={this.handleFilterChange} />,
                    <SubTypeFilterButton key="20" active={this.state.artwork.q.subType && this.state.artwork.q.subType.value == 20} d={{ display: 'Sculptures', value: 20 }} onClick={this.handleFilterChange} />,
                    <SubTypeFilterButton key="7" active={this.state.artwork.q.subType && this.state.artwork.q.subType.value == 7} d={{ display: 'Other', value: 7 }} onClick={this.handleFilterChange} />
                ];
                typeString = 'Decor';
                break;
            case 'furniture':
                subTypes = [
                    <SubTypeFilterButton key="8" active={this.state.artwork.q.subType && this.state.artwork.q.subType.value == 8} d={{ display: 'Chairs', value: 8 }} onClick={this.handleFilterChange} />,
                    <SubTypeFilterButton key="9" active={this.state.artwork.q.subType && this.state.artwork.q.subType.value == 9} d={{ display: 'Sofas', value: 9 }} onClick={this.handleFilterChange} />,
                    <SubTypeFilterButton key="10" active={this.state.artwork.q.subType && this.state.artwork.q.subType.value == 10} d={{ display: 'Benches', value: 10 }} onClick={this.handleFilterChange} />,
                    <SubTypeFilterButton key="11" active={this.state.artwork.q.subType && this.state.artwork.q.subType.value == 11} d={{ display: 'Storage', value: 11 }} onClick={this.handleFilterChange} />,
                    <SubTypeFilterButton key="12" active={this.state.artwork.q.subType && this.state.artwork.q.subType.value == 12} d={{ display: 'Tables', value: 12 }} onClick={this.handleFilterChange} />
                ];
                typeString = 'Furniture';
                break;
            case 'jewelry':
                subTypes = [
                    <SubTypeFilterButton key="1" active={this.state.artwork.q.subType && this.state.artwork.q.subType.value == 1} d={{ display: 'Necklaces', value: 1 }} onClick={this.handleFilterChange} />,
                    <SubTypeFilterButton key="0" active={this.state.artwork.q.subType && this.state.artwork.q.subType.value == 0} d={{ display: 'Rings', value: 0 }} onClick={this.handleFilterChange} />,
                    <SubTypeFilterButton key="2" active={this.state.artwork.q.subType && this.state.artwork.q.subType.value == 2} d={{ display: 'Bracelets', value: 2 }} onClick={this.handleFilterChange} />,
                    <SubTypeFilterButton key="3" active={this.state.artwork.q.subType && this.state.artwork.q.subType.value == 3} d={{ display: 'Watches', value: 3 }} onClick={this.handleFilterChange} />,
                    <SubTypeFilterButton key="7" active={this.state.artwork.q.subType && this.state.artwork.q.subType.value == 7} d={{ display: 'Other', value: 7 }} onClick={this.handleFilterChange} />
                ];
                typeString = 'Jewelry';
                break;
            case 'lighting':
                subTypes = [
                    <SubTypeFilterButton key="13" active={this.state.artwork.q.subType && this.state.artwork.q.subType.value == 13} d={{ display: 'Wall Lights and Scones', value: 13 }} onClick={this.handleFilterChange} />,
                    <SubTypeFilterButton key="14" active={this.state.artwork.q.subType && this.state.artwork.q.subType.value == 14} d={{ display: 'Table Lamps', value: 14 }} onClick={this.handleFilterChange} />,
                    <SubTypeFilterButton key="15" active={this.state.artwork.q.subType && this.state.artwork.q.subType.value == 15} d={{ display: 'Floor Lamps', value: 15 }} onClick={this.handleFilterChange} />,
                    <SubTypeFilterButton key="16" active={this.state.artwork.q.subType && this.state.artwork.q.subType.value == 16} d={{ display: 'Chandeliers/Pendants', value: 16 }} onClick={this.handleFilterChange} />,
                    <SubTypeFilterButton key="7" active={this.state.artwork.q.subType && this.state.artwork.q.subType.value == 7} d={{ display: 'Other', value: 7 }} onClick={this.handleFilterChange} />
                ];
                typeString = 'Lighting';
                break;
            default:
                let genre;
                for (let id in Genre.values) {
                    genre = Genre.values[id];
                    subTypes.push(<SubTypeFilterButton key={genre.value} active={this.state.artwork.q.genre && this.state.artwork.q.genre.value == genre.value} d={genre} name="genre" onClick={this.handleFilterChange} />);
                }
                filterRenderOptions.height = true;
                filterRenderOptions.mediums = true;
                filterRenderOptions.width = true;
                typeString = 'Artwork';
                break;
        }
        const filters = [];
        let height, price, temp, value, width;
        for (let id in this.state.artwork.q) {
            value = this.state.artwork.q[id];
            if (!value) {
                continue;
            }
            let display;
            switch (id) {
                case 'dir':
                case 'limit':
                case 'offset':
                case 'order':
                    continue;
                case 'maxHeight':
                case 'minHeight':
                    if (!height) {
                        height = {};
                    }
                    height[id] = value;
                    break;
                case 'maxPrice':
                case 'minPrice':
                    if (!price) {
                        price = {};
                    }
                    price[id] = value;
                    break;
                case 'maxWidth':
                case 'minWidth':
                    if (!width) {
                        width = {};
                    }
                    width[id] = value;
                    break;
                case 'subType':
                    display = `${typeString} Type`;
                // Intentional fallthrough
                default:
                    if (value.display != undefined) {
                        value = value.display;
                    } else if (Array.isArray(value)) {
                        if (!value.length) {
                            continue;
                        }
                        temp = value.map(function (d) { return d.display; });
                        value = temp.join(', ');
                    }
                    filters.push(<FilterDisplayButton key={id} display={display} type={id} value={value} onClick={this.handleFilterDisplayButtonClick} />);
                    break;
            }
        }
        if (price) {
            const minPrice = price.minPrice || 0;
            if (price.maxPrice) {
                value = `${minPrice} - ${price.maxPrice}`;
            } else {
                value = `${minPrice} and up`;
            }
            filters.push(<FilterDisplayButton key="price" type="price" value={value} onClick={this.handleFilterDisplayButtonClick} />);
        }
        if (height && filterRenderOptions.height) {
            const minHeight = height.minHeight || 0;
            if (height.maxHeight) {
                value = `${minHeight} - ${height.maxHeight}`;
            } else {
                value = `${minHeight} and up`;
            }
            filters.push(<FilterDisplayButton key="height" type="height" value={value} onClick={this.handleFilterDisplayButtonClick} />);
        }
        if (width && filterRenderOptions.width) {
            const minWidth = width.minWidth || 0;
            if (width.maxWidth) {
                value = `${minWidth} - ${width.maxWidth}`;
            } else {
                value = `${minWidth} and up`;
            }
            filters.push(<FilterDisplayButton key="width" type="width" value={value} onClick={this.handleFilterDisplayButtonClick} />);
        }
        return (
            <React.Fragment>
                <div className="container">
                    <div className="category__container">
                        <h2 className="sidebar__title">Browse {typeString}</h2>
                        {subTypes}
                    </div>
                </div>
                <div className="container--sidebar__outer">
                    <Spaced className="container--sidebar-left">
                        <div className={filterClassName}>
                            <a href="#" className="btn btn--save btn--outline btn--light" onClick={this.handleFilterHide}>Apply Filter</a>
                            <div className="control__holder" onClick={this.handleFilterHide}>
                                <div className="icon__holder icon--close">
                                    <div className="icon__inner">
                                        <div className="icon__bar" />
                                        <div className="icon__bar" />
                                        <div className="icon__bar" />
                                    </div>
                                </div>
                            </div>
                            <FilterContainer
                                ref={this._handleFilterRef}
                                filters={this.state.artwork.q}
                                renderOptions={filterRenderOptions}
                                search={this.state.search}
                                onChange={this.handleFilterChange} />
                        </div>
                        <div className="show--m text--center">
                            <h2 className="sidebar__title">Browse {typeString.toLowerCase()}</h2>
                        </div>
                        <a href="#" className="btn btn--outline btn--fulwidth btn--dark filter--button show--m" onClick={this.handleFilterShow}>
                            <span className="i i--filter" />
                            <React.Fragment>&nbsp;Filter</React.Fragment>
                        </a>
                        <div className="container__row" style={{ minHeight: '1200px' }}>
                            <div>
                                <FilterContainer
                                    widgetClassName="sidebar__widget--right"
                                    filters={this.state.artwork.q}
                                    sortOptions={this.sortOptions}
                                    onChange={this.handleFilterChange} />
                                <div className="filters__cont">
                                    {filters}
                                </div>
                                {
                                    this.state.artwork.data &&
                                    this.state.artwork.data.length == 0 &&
                                    <div className="blank__cont blank--fill blank--single blank--witharr">
                                        <p className="blank__text">No results. Try removing filters.</p>
                                    </div>
                                }
                                {
                                    this.state.artwork.q.order == 3 &&
                                    <React.Fragment>
                                        {
                                            !Artcloud.auth.isauthed &&
                                            <div className="blank__cont blank--fill blank--single">
                                                <p className="blank__text">Want to find the perfect piece? <a href="#" onClick={this.handleSignUpClick}>Sign up</a> for {publicCompany(true)} to receive new art suggestions every day!</p>
                                            </div>
                                        }
                                        {
                                            Artcloud.auth.isauthed &&
                                            this.state.artwork.data &&
                                            this.state.artwork.data.length == 0 &&
                                            <div className="blank__cont blank--fill blank--single">
                                                <p className="blank__text">We don't have any suggested works for you right now. Favorite more art and you'll receive new art suggestions every day!</p>
                                            </div>
                                        }
                                    </React.Fragment>
                                }
                                <ArtworkGridContainer id="art" sizeClassName="art__container" onWaypointEnter={this.handleWaypointEnter}>
                                    {
                                        this.state.artwork.data &&
                                        this.state.artwork.data.length > 0 &&
                                        this.state.artwork.data.map((d) => <ArtworkCell key={d.ArtId} className="grid--4" d={d} onLikeChange={this.handleArtworkLikeChange} cols={3} gutter={58.3} />)
                                    }
                                </ArtworkGridContainer>
                                {
                                    this.state.artwork.loading &&
                                    <LoadingIndicator />
                                }
                            </div>
                        </div>
                    </Spaced>
                </div>
                {
                    this.state.listArtworkAddModal &&
                    this.state.listArtworkAddModal.visible &&
                    <ListArtworkAdd data={this.state.listArtworkAddModal.data} onClose={this.handleListArtworkAddModalClose} />
                }
            </React.Fragment>
        );
    }
}

class FilterDisplayButton extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        if (event) {
            event.preventDefault();
        }
        this.props.onClick(this.props.type);
    }

    render() {
        let type = this.props.type;
        if (type == 'q') {
            type = 'search';
        }
        return (
            <a href="#" className="filters__anchor" onClick={this.handleClick}>
                <span className="i i--close" />
                <React.Fragment>{this.props.display || type}: {this.props.value}</React.Fragment>
            </a>
        );
    }
}

class SubTypeFilterButton extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        if (event) {
            event.preventDefault();
        }
        let value;
        if (!this.props.active) {
            value = this.props.d;
        }
        this.props.onClick(this.props.name || 'subType', value);
    }

    render() {
        let className = 'category__box';
        if (this.props.active) {
            className += ' category__box--active';
        }
        return (
            <a href="#" className={className} onClick={this.handleClick}>
                <span className="category__box__text">
                    {this.props.d.display}
                </span>
            </a>
        );
    }
}

export default Browse;